import { createStorageAdapter } from "./storageAdapter.mjs";
function configureStorageAdapter(opts) {
  if (opts.getPlatformStorage) {
    return;
  }
  let replicant;
  void opts.replicantClientPromise.then((replicantClient) => {
    replicant = replicantClient;
  });
  const getReplicant = () => {
    if (!replicant) {
      throw Error("Replicant client is not initialized");
    }
    return replicant;
  };
  const storageAdapter = createStorageAdapter(getReplicant);
  opts.gcinstant.storage.setStorageAdapter(storageAdapter);
}
export {
  configureStorageAdapter
};
